import {rangesAndConditionalsByVitalTitle} from './resultLevelsCases';

/**
 * Converts a value within a specified range to a percentage within a new range.
 *
 * @function
 * @param {number} value - The value to be converted.
 * @param {number} min - The minimum value of the original range.
 * @param {number} max - The maximum value of the original range.
 * @param {number} newMin - The minimum value of the new range.
 * @param {number} newMax - The maximum value of the new range.
 * @returns {number} The converted value within the new range.
 */
const fitToPercentage = (value, min, max, newMin, newMax) => {
  const percentage = ((value - min) / (max - min)) * 100;
  const fittedValue = (newMax - newMin) * (percentage / 100) + newMin;
  return fittedValue;
};

/**
 * Retrieves result level ranges and related information for a given result and vital title.
 *
 * @function
 * @param {number} result - The result value.
 * @param {string} title - The vital title.
 * @param {boolean} isModalPopup - Indicates if the result is used in a modal popup.
 * @param {number} userActualAge - The actual age of the user.
 * @returns {Object} An object containing result level information.
 */
export const getResultLevelRanges = (result, title, isModalPopup, userActualAge) => {
  let level = 'Unknown Range';
  let colour = '';
  let colourLineRange = [];
  let circlePosition = 0.0;

  const fillColourLineAndCirclePosition = (vitalList, commonProps, customTooltipColor) => {
    if (vitalList === undefined) return;

    const tooltipColor = customTooltipColor ?? 'Yellow';
    vitalList.forEach(e => {
      colourLineRange.push({
        offset: `${fitToPercentage(e.position, ...commonProps)}%`,
        color: e.color,
        tooltip: tooltipColor,
      });
    });
    circlePosition = `${fitToPercentage(result, ...commonProps)}%`;
    if (title === 'Mental Stress Index') circlePosition = `${fitToPercentage(result - 1, ...theCommonProps)}%`; //Added -1 to result because the range on nuralogix is from 1-6
  };

  const vitalList = rangesAndConditionalsByVitalTitle[title].range;
  const conditionals = rangesAndConditionalsByVitalTitle[title].conditionals;
  const theCommonProps = rangesAndConditionalsByVitalTitle[title].fitToPercentageProps;
  fillColourLineAndCirclePosition(vitalList, theCommonProps);
  if (conditionals !== undefined)
    ({level, colour} = conditionals(result, title === 'Facial Skin Age' ? userActualAge : isModalPopup));

  if (isModalPopup) {
    return {
      nuralogixLevel: level,
      colourCircleSlider: colour,
      colourLineRanges: colourLineRange,
      circlePosition: circlePosition,
    };
  }
  return {level, colour};
};
